import React, { cloneElement, useContext, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import PrimaryButton from '../../../ui/PrimaryButton';
import ActionButton, { ActionButtonItem, borderColors, splitMenuItemsIntoSections } from '../../../ui/ActionButton';
import * as XCol from "../../../framework.core/XExportColumn";
import useFunctionKeys from '../../../hooks/useFunctionKeys';
import useGlobalOkDialog from '../../../hooks/useGlobalOkDialog';
import useSystemSettings from '../../../hooks/useSystemSettings';
import BicInfoAreaHistory from '../../common/BicInfoAreaHistory';
import InfoAreaDrawer from '../../../uiControls/infoArea/InfoAreaDrawer';
import { NavigationType, openNewPage } from '../../../util/navigationHelpers';
import { billList, TableColumn, TableSettings } from '../../../tableSettings';
import constants from '../../../constants';
import ApplicationContext from '../../../ApplicationContext';
import lockRed from '../../../img/lock_red.png';
import {
  CurrencyAmountRenderer,DateRenderer,DateTimeRenderer,NullableCheckboxIconRenderer,
  TextAlignLeftRenderer,TextAlignRightRenderer,TextRenderer,
} from '../../../uiControls/SmartTableRenderers';
import JobListViewContext, { IJobListViewContext, RightClickContext } from '../../common/JobListViewContext';
import AbstractListView, {
  DataFetchResult,ExportRowRenderer,ListCustomFilterRenderer,ListOrderBy,ListRowRenderer
} from "../../common/AbstractListView";
import { Search } from '../../../filtering';
import {getJobNameFromInvBillCrDbJobType,getOpTypeConstant,JobNames} from '../../../framework.core/JobNames';
import { BillListItem } from '../../../fms.data/models/BillListItem';
import IfmsModal from "../../../ui/IfmsModal";
import ListViewShortcutMenu from '../../common/ListViewShortcutMenu';
import useGlobalYesNoDialog from '../../../hooks/useGlobalYesNoDialog';
import ToolboxMenuItem from '../../../uiControls/ToolboxMenuItem';
import Menu, { IfmsMenuItem } from '../../../ui/menu/Menu';
import JobListSuntekCommand from '../../common/JobListSuntekCommand';
import { BicTypeFilterRenderer, DraftFilterRenderer, PeriodRenderer, RecognizedFilterRenderer, RecognizedRenderer, StatusNotUseFileLockedRenderer, VoidFilterRenderer } from '../../common/commonListRenderers';
import { FmsSecTask } from '../../../fms.core/constants';
import fastStorage from '../../../fastStorage';
import BillInformation from '../../reports/BillInformation';
import VendorBalanceDetails from '../../reports/AccountBalance';
import { nowDate } from '../../../dateUtils';
import { SuntekSettings, SystemSettings } from '../../../ifmsTypes';
import { findSecurityTask, getSecBySecTask } from '../../../util';
import { useJournal } from '../general/journal/JournalListView';
import useSuntekSettings from '../../../hooks/useSuntekSettings';
import { FormType, SecType } from '../../../fms.enum';
import CopyInvoice from '../common/CopyInvoice';
import { getFmsGlobal } from '../../../globals';
import HistoryView from '../../reports/HistoryView';
import PrintBill from './report/PrintBill';
import { FmsSecCntr } from '../../../fms.core/constants/FmsSecCntr';
import CheckBoxUncontrolled from '../../../ui/CheckBoxUncontrolled';
import { CurrencyAmountValue, nullableCheckBoxValue } from '../../common/commonExportFormat';

function IndicatorRenderer({ data, row }: any) {
  const jobListContext = useContext(JobListViewContext);
  const l = data[row.index];
  let dataTooltip = ''; 
  const lStatus = (l as any).status as string;
  if (lStatus === 'PC') dataTooltip = 'Period Close';

  let content: React.ReactNode = <></>;
  if (lStatus === 'PC')
    content = <img height="7px" src={lockRed} id={'redIcon'} style={{ position: 'relative', top: '0px' }} alt="" />;

  function onIndicatorClick() {
    if (jobListContext.rowExtrasId) {
      return; // Some row is already selected
    }

    jobListContext.setRowExtrasId(data[row.index].id);
  }

  return (
    <div 
      className="ifms-table-default" 
      id={`ifms-table-default-${row.index}`}  
      data-tooltip={dataTooltip} 
      style={{ width: '100%', minHeight: '22px' }}
      onClick={onIndicatorClick}>
        {content}
        </div>
    //<div className="ifms-table-default" style={{width: '100%', minHeight: '22px'}}>{content}</div>
  );
}

function DraftRenderer({ cell }: any) {
  if (cell && cell.value) {
    return (
      <div data-tooltip={'Draft'} className="ifms-table-default">
        <span style={{ color: 'green' }}>V</span>
      </div>
    );
  }

  return <div className="ifms-table-default"></div>;
}

function ConfirmedRenderer({ value, row }: any) {
  
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const [showGlobalOkDialog] = useGlobalOkDialog();
  const suntekSettings = useSuntekSettings();

  if(jobListContext.opType === constants.opTypes.warehousing){
    let secCont = appContext.securityControls ? appContext.securityControls[JobNames.WHBill] : null;
    if (!secCont) {
      secCont = [
        { secCntr: FmsSecCntr.WHBillConfirmed, contName: 'chkConfirmed' },
        { secCntr: FmsSecCntr.WHBillDraft, contName: 'chkDraft' }

    ];
      appContext.setSecurityControls(JobNames.WHBill, secCont);
    }
  }else{
    let secCont = appContext.securityControls ? appContext.securityControls[JobNames.Bill] : null;
      if (!secCont) {
        secCont = [
          { secCntr: FmsSecCntr.BillGivCredit, contName: 'cmdNew10' },
          { secCntr: FmsSecCntr.BillCancelCredit, contName: 'cmdNew12' },
          { secCntr: FmsSecCntr.BillConfirmed, contName: 'chkConfirmed' },
          { secCntr: FmsSecCntr.BillDraft, contName: 'chkDraft' }
      ];
        appContext.setSecurityControls(JobNames.Bill, secCont);
      }
  }


  async function updateConfirmed(newValue: boolean) {
    await appContext.api.setBillConfirmed(row.original.id, newValue);
    row.original.confirmed = newValue;
    jobListContext.updateDataRow(row.original);
  }

  function findClickedCell(element: Element): Element | null {
    for (let i = 0; i < 6; ++i) {
      if (!element) {
        break;
      }
      if (Array.from(element.classList).some(className => className.startsWith('row-'))) {
        return element;
      }
      element = element.parentNode as Element;
    }
    return null;
  }

  return (
    <div style={{ width: '100%', textAlign: 'center' }}>
      <CheckBoxUncontrolled
        key={row.original.id}
        initialValue={Boolean(value)}
        onChange={updateConfirmed}
        disabled={appContext.getControlDisableStatus(jobListContext.opType === constants.opTypes.warehousing?JobNames.WHBill:JobNames.Bill, 'chkConfirmed', FormType.ModeEdit)}
        allowOnChange={async (e) => {
          if (!e) return false;

          e?.stopPropagation();

          const element = findClickedCell(e.currentTarget);
          if (!element) {
            await showGlobalOkDialog(<p>Cannot find hover element</p>, false, null, 'warning');
            return false;
          }

          const classes = element.classList;
          const mouseOverRowIndex = Array.from(classes).find(className => className.includes('row-'))?.match(/\d+$/)?.[0];

          if (!mouseOverRowIndex || !jobListContext.data) {
            await showGlobalOkDialog(<p>Cannot find hover data</p>, false, null, 'warning');
            return false;
          }

          const rowData = jobListContext.data[parseInt(mouseOverRowIndex)];
          if (rowData.void > 0) {
            await showGlobalOkDialog(<p>This Bill has been voided.</p>);
            return false;
          } else if (rowData.paidAmount !== 0) {
            await showGlobalOkDialog(<p>This Bill has been already paid.</p>);
            return false;
          } else if (rowData.draft) {
            await showGlobalOkDialog(<p>This Bill is Draft.</p>);
            return false;
          } else {
            return true;
          }
        }} />
    </div>
  );
}

function VoidRenderer({ cell }: any) {
  if (cell && cell.value === 1) {
    return (
      <div data-tooltip={'Void'} className="ifms-table-default">
        <span style={{ color: 'red' }}>V</span>
      </div>
    );
  }

  return <div className="ifms-table-default"></div>;
}

function formatData(data: Array<BillListItem>) {
  return data.map((d: BillListItem) => ({
    ...d,
    status: d.draft ? '' : d.status
  }));
}

function useBillOperations() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);

  // function switchToHbl(jobName: JobNames, refNo:string) {
  //   const opType = getOpTypeConstant(jobName);
  //   jobListContext.setFilterForScreenExternally(`/common/joblistview/hbl/${opType}`, 'refNo', 'Ref No', refNo, 'updated', false);
  //   openNewPage(history, `/common/joblistview/hbl/${opType}`, NavigationType.newPage);
  // }

  // function switchToMbl(jobName: JobNames, mblNo:string) {
  //   const opType = getOpTypeConstant(jobName);
  //   jobListContext.setFilterForScreenExternally(`/common/joblistview/mbl/${opType}`, 'mblNo', 'Mbl No', mblNo, 'updated', false);
  //   openNewPage(history, `/common/joblistview/mbl/${opType}`, NavigationType.newPage);
  // }
  function switchToList(jobName: JobNames, jobId: number, refNo: string, hblNo: string) {
    // const blType = isMasterJob(jobName) ? 'mbl' : 'hbl';
    let blType = '';
    let columnLabel = '';
    let columnIdEx = null;
    let textEx = null;
    switch(jobName) {
      case JobNames.OIMbl:
        blType = 'mbl';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.OIHbl:
        blType = 'hbl';
        columnLabel = 'HBL #';
        columnIdEx = 'hblNo';
        textEx = hblNo;
        break;
      case JobNames.OEMbl:
        blType = 'oeMbl';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.OEHbl:
        blType = 'oeHbl';
        columnLabel = 'HBL #';
        columnIdEx = 'hblNo';
        textEx = hblNo;
        break;
      case JobNames.AIMbl:
        blType = 'aiMawb';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.AIHbl:
        blType = 'aiHawb';
        columnLabel = 'HAWB #';
        columnIdEx = 'hawbNo';
        textEx = hblNo;
        break;
      case JobNames.AEMbl:
        blType = 'aeMawb';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.AEHbl:
        blType = 'aeHawb';
        columnLabel = 'HAWB #';
        columnIdEx = 'hawbNo';
        textEx = hblNo;
        break;
      case JobNames.OtherOP:
        blType = 'otherShipment';
        columnLabel = 'Ref. #';
        columnIdEx = 'refNo';
        textEx = refNo;
        break;
      case JobNames.WHRcv:
        blType = 'whReceiving';
        columnLabel = 'Receiving ID';
        columnIdEx = 'receiveNo';
        textEx = refNo;
        break;
      case JobNames.WHShip:
        blType = 'whShipping';
        columnLabel = 'Shipping ID';
        columnIdEx = 'shipNo';
        textEx = refNo;
        break;
      case JobNames.BTOrder:
        blType = 'btOrder';
        columnLabel = 'PRO #';
        columnIdEx = 'orderNo';
        textEx = refNo;
        break;
      case JobNames.BTLoadPlan:
        blType = 'btLoadPlan';
        columnLabel = 'Load #';
        columnIdEx = 'loadNo';
        textEx = refNo;
        break;
    }
    const opType = getOpTypeConstant(jobName);
    jobListContext.setFilterForScreenExternally(`/common/joblistview/${blType}/${opType}`, 'id', columnLabel, jobId.toString(), 'update', false, true, null, columnIdEx, textEx, false, true);
    openNewPage(history, `/common/joblistview/${blType}/${opType}`, NavigationType.newPage);
  }

  function switchToParentFor(bill: BillListItem) {
    if (!bill) {
      return;
    }

    // if (bill.type === JobNames.OIMbl) {
    //   switchToMbl(bill.parentNo ?? '');
    // }
    // if (bill.type === JobNames.OIHbl) {
    //   switchToHbl(bill.refNo ?? '');
    // }
    switchToList(getJobNameFromInvBillCrDbJobType(bill.jobType), bill.tbId, bill.refNo, bill.hblNo);

  }

  return { switchToParentFor };
}

function useSelectedBillOperations() {
  const fmsGlobal = getFmsGlobal();
  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const history = useHistory();
  const { switchToParentFor } = useBillOperations();

  const selectedElement = jobListContext.selectedElement as BillListItem;

  const [showGlobalOkDialog] = useGlobalOkDialog();
  const [showGlobalYesNoDialog] = useGlobalYesNoDialog();

  async function edit() {
    if (!selectedElement) {
      return;
    }

    if (!selectedElement.jobType) {
      //await showGlobalOkDialog(<p>Operation currently not implemented for this type</p>);
      return;
    }

    const id = selectedElement.id;
    const viewUrl = `/accounting/bill/view/${getJobNameFromInvBillCrDbJobType(selectedElement?.jobType)}/${selectedElement?.tbId}/${id}`;
    const editUrl = `/accounting/bill/edit/${getJobNameFromInvBillCrDbJobType(selectedElement?.jobType)}/${selectedElement?.tbId}/${id}`;

    // if (jobListContext.hasOpenedScreenInAnyOperationStartingWithUrlWithoutMe(`/accounting/bill/edit`, editUrl)) {
    //   await showGlobalOkDialog(<p>Edit operation is already in progress.</p>);
    //   return;
    // }

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(editUrl, [editUrl, viewUrl]);
  }

  async function view() {
    if (!selectedElement) {
      return;
    }

    if (!selectedElement.jobType) {
      //await showGlobalOkDialog(<p>Operation currently not implemented for this type</p>);
      return;
    }

    const id = selectedElement.id;
    const editUrl = `/accounting/bill/edit/${getJobNameFromInvBillCrDbJobType(selectedElement?.jobType)}/${selectedElement?.tbId}/${id}`;
    const viewUrl = `/accounting/bill/view/${getJobNameFromInvBillCrDbJobType(selectedElement?.jobType)}/${selectedElement?.tbId}/${id}`;

    const listSec = findSecurityTask(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHBill : FmsSecTask.AcctBillList));
    const urls = [viewUrl];
    if (listSec?.grantEdit) urls.push(editUrl)

    jobListContext.moveToOpenedScreenInAnyOperationStartingWithUrl(viewUrl, urls);
  }

  async function viewPaymentHistory() {
    if (!selectedElement) {
      return;
    }

    const jobId = selectedElement.id;
    const jobName = JobNames.Bill;
    const jobType = selectedElement.jobType

    const viewUrl = `/accounting/acPaymentHistoryView/${jobName}/${jobId}/${getJobNameFromInvBillCrDbJobType(jobType)}`;
    openNewPage(history, viewUrl, NavigationType.newPage);
  }

  async function deleteItem() {
    if (!selectedElement) {
      await showGlobalOkDialog('Cannot delete!',false,null,'warning');
      return;
    }

    if (
      jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/bill/edit/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${selectedElement.id}`) ||
      jobListContext.hasOpenedScreenStartingWithUrl(`/accounting/bill/view/${getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}/${selectedElement.tbId}/${selectedElement.id}`)
    ) {
      await showGlobalOkDialog('Need to close Bill first', false, null, "warning");
      return;
    }

    const doDelete = await showGlobalYesNoDialog(
      <div>
        <h3>Confirm to Delete?</h3>
      </div>
    ,false, 0, true, 'warning');

    if (doDelete) {
      const apiResult = await appContext.api.deleteJobDetail(JobNames.Bill, { id: selectedElement.id, opAcctBlockAfterClosed: fmsGlobal?.OPAcctBlockAfterClosed??false });
      if (apiResult && apiResult.success) {
        jobListContext.reloadData();
      } else {
        const message = apiResult?.message ?? 'Cannot delete!';
        await showGlobalOkDialog(message,false,null,'warning');
      }
    }
  }

  function switchToParent() {
    const selectedElement = jobListContext.selectedElement as BillListItem;
    switchToParentFor(selectedElement);
  }

  return { edit, view, switchToParent, deleteItem, viewPaymentHistory };
}

function RightClickMenu({ dismiss }: { dismiss: VoidFunction }) {
  const { edit, view, deleteItem, switchToParent } = useSelectedBillOperations();
  const jobListContext = useContext(JobListViewContext);
  const appContext = useContext(ApplicationContext);

  const listSec = findSecurityTask(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHBill : FmsSecTask.AcctBillList));
    const selectedElement = jobListContext.selectedElement as BillListItem;
  // const isDraft = jobListContext.selectedElement.draft;
  const isWarehouingList = jobListContext.opType === constants.opTypes.warehousing;

  const items = [
    { label: 'View', shortcut: 'F9', separator: !listSec?.grantEdit && !listSec?.grantDel },
    { label: 'Edit', shortcut: 'F3', separator: !listSec?.grantDel, hidden: !listSec?.grantEdit },
    { label: 'Delete', shortcut: '', separator: true, hidden: !listSec?.grantDel },
    { label: 'Search', shortcut: 'F5', separator: false },
    { label: isWarehouingList ? 'Go to W/H List' : (selectedElement.jobType === 'ODM'? 'Go to Manifest List' : 'Go to Load List'), 
      shortcut: 'F6', separator: false },
    { label: constants.Doc_Server, shortcut: 'F8', separator: true, newCol: true },
  ];

  const menuItems: ActionButtonItem[] = items.map((i, index) => ({
    label: <ToolboxMenuItem name="bill-list-sub-menu" width="190px" label={i.label} shortcut={i.shortcut} />,
    separator: i.separator,
    selected: false,
    newCol: i.newCol,
    index,
    hidden: i?.hidden ?? false,
  }));

  function onMenuItemSelected(item: IfmsMenuItem) {
    switch (item.index) {
      case 0:
        view();
        break;
      case 1:
        edit();
        break;
      case 2:
        deleteItem();
        break;
      case 3:
        jobListContext.triggerTableSearch('F5');
        break;
      case 4:
        switchToParent();
        break;
      case 5:
        jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
        break;
      case 6:
        jobListContext.reloadData();
        break;
      default:
        break;
    }
    dismiss();
  }

  return (
    <Menu
      variant="plain"
      specialMenu='rightClickContext'
      items={splitMenuItemsIntoSections(menuItems)}
      mode="vertical"
      onMenuItemSelected={onMenuItemSelected}
      subMenuStyle={{
        minWidth: 150,
        whiteSpace: 'nowrap',
      }}
      menuStyle={(i: number) => ({
        maxHeight: '300px',
        overflowY: 'hidden',
        padding: 0,
        borderTop: `3px solid ${borderColors[i % borderColors.length]}`,
        paddingTop: 10,
      })}
      dismiss={dismiss}
    />
  );
}

function BillListCommands() {
  const history = useHistory();
  const jobListContext = useContext(JobListViewContext);
  const [selectedPopupMenuItem, setSelectedPopupMenuItem] = useState<ActionButtonItem | null>(null);
  const [showGlobalOkDialog] = useGlobalOkDialog();

  const selectedElement = jobListContext.selectedElement as BillListItem;

  const { edit, view, deleteItem, viewPaymentHistory } = useSelectedBillOperations();
  
  const appContext = useContext(ApplicationContext);
  const listSec = findSecurityTask(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHBill : FmsSecTask.AcctBillList));
  const hasSecCp = getSecBySecTask(appContext, FmsSecTask.AcctCustPayment, SecType.Add);
  const hasSecBp = getSecBySecTask(appContext, FmsSecTask.AcctBillPayment, SecType.Add);

  const hasSelectedRow = !!selectedElement;

  const onPopupClose = () => {
    setSelectedPopupMenuItem(null);
  }

  async function onCustomerBillAction(item: ActionButtonItem) {
    let link = '';
    switch (item.index) {
      case 0:
        link = `/accounting/acCustomerPayment/add`;
        break;
      case 1:
        link = `/accounting/acBillPayment/add`;
        break;
      case 2:

      jobListContext.setFilterForScreenExternally('/common/joblistview/acCustomerPayment/accounting', 
        'invoiceNo', 'Billings', selectedElement.billNo, 'updated', false, true, null);
        openNewPage(history, '/common/joblistview/acCustomerPayment/accounting', NavigationType.newPage);
        return;
      case 3:

      jobListContext.setFilterForScreenExternally('/common/joblistview/acBillPayment/accounting', 
        'invoiceNo', 'Billings', selectedElement.billNo, 'updated', false, true, null);
        openNewPage(history, '/common/joblistview/acBillPayment/accounting', NavigationType.newPage);
        return;
    }

    if (jobListContext.hasOpenedScreenStartingWithUrl(link)) {
      await showGlobalOkDialog(<p>Payment New Operation is already in progress</p>);
      return;
    }

    openNewPage(history, `${link}/${selectedElement.vendorId}`, NavigationType.newPage);
  }

  function onHistoryBtnAction(item: ActionButtonItem) {
    switch (item.index) {
      case 0:
        viewPaymentHistory();
        break;
      case 1:
        setSelectedPopupMenuItem({ label: 'View History', popupWidth: 920, popupComponent: <HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={JobNames.Bill} /> });
        break;
      // case 2:
      //   setSelectedPopupMenuItem({ label: 'Delete History (Bill)', popupWidth: 920, popupComponent: <HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={JobNames.Bill} viewDeleteHistory={true} /> })
      //   return;
    }
  }

  async function copyBill() {
    if (selectedElement.draft) {
      await showGlobalOkDialog(<p>The Draft Bill cannot be copied.</p>,false,null,'error');
      return;
    }
    setSelectedPopupMenuItem({
      label:'Select a target B/L to be linked',
      popupWidth: 450,
      popupComponent:
        <CopyInvoice
          jobId={selectedElement.id}
          jobName={JobNames.Bill}
          srcJobName={getJobNameFromInvBillCrDbJobType(selectedElement.jobType)}
          srcJobId={selectedElement.tbId}
          onPopupClose={onPopupClose}
        />
    });
  }

  async function vendorBalance() {
    if (selectedElement.vendorId <= 0 && (selectedElement.vendorName === null || selectedElement.vendorName === '')) {
      await showGlobalOkDialog(<p>You didn't enter Vendor.</p>,false,null,'error');
      return;
    }
    setSelectedPopupMenuItem({
      label: 'Balance',
      popupWidth: 780,
      popupComponent:
        <VendorBalanceDetails
          jobId={selectedElement.id}
          jobName={jobListContext.opType === constants.opTypes.warehousing ? JobNames.WHBill : JobNames.Bill}
          onPopupClose={onPopupClose}
          //toDate={invoice.postDate || ''}
          toDate={nowDate()}
          comId={selectedElement.vendorId}
          comType={'C'}
          branch={''}
          subCode={''}
          customerName={selectedElement.vendorName}
        />
    });
  }
  
  const canBeEdit = hasSelectedRow && listSec?.grantEdit;
  const canBeDeleted = hasSelectedRow && listSec?.grantDel;
   const disablePrint = !hasSelectedRow; //&& selectedElement.draft;     //<240523.dwshin Invoice/Bill/CRDB - Draft인 항목을 출력 할 때, Title에 Draft 나오도록 추가>
  // const selectRowDraft = hasSelectedRow && selectedElement.draft;
  const canBeCopied = hasSelectedRow && listSec?.grantAdd;

  return (
    <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
      <div className="ifms-common-no-vertical-separator">
        <PrimaryButton name='bill-list-view-button' size="regular" disabled={!hasSelectedRow} onClick={view}>View</PrimaryButton>&nbsp;
        <PrimaryButton name='bill-list-edit-button' size="regular" disabled={!canBeEdit} onClick={edit}>Edit</PrimaryButton>&nbsp;
        <PrimaryButton name='bill-list-delete-button' size="regular" disabled={!canBeDeleted} onClick={deleteItem}>Delete</PrimaryButton>&nbsp;
        {(jobListContext.opType !== constants.opTypes.warehousing && jobListContext.opType !== constants.opTypes.order && jobListContext.opType !== constants.opTypes.load) && <>
          <PrimaryButton 
            name='bill-list-copy-button' 
            size="regular"
            disabled={!canBeCopied}
            onClick={copyBill}>
            Copy
          </PrimaryButton>
        </>}
      </div>
      <div className={!appContext.useDarkMode ? "ifms-common-vertical-separator" : "ifms-common-vertical-separator-darkmode"}>
        {(jobListContext.opType === constants.opTypes.warehousing || jobListContext.opType === constants.opTypes.order || jobListContext.opType === constants.opTypes.load) && <>
          <PrimaryButton name='bill-list-print-button' size="regular" disabled={disablePrint} onClick={() => setSelectedPopupMenuItem({ label: 'Print Bill', popupComponent: <PrintBill selectedElement={selectedElement} /> })}>Print</PrimaryButton>&nbsp;
          {(hasSecCp || hasSecBp) &&
            <>
              <ActionButton
                name='bill-list-pay-button'
                type="primary"
                items={[
                  { label: 'New Customer Pay', separator: false, index: 0, hidden: !hasSecCp, name: "bill-list-sub-custpay-button" },
                  { label: 'New Bill Pay', separator: true, index: 1, hidden: !hasSecBp, name: "bill-list-sub-billpay-button" },
                  { label: 'Customer Pay List', separator: false, index: 2, hidden: !hasSecCp, name: "bill-list-sub-custpayList-button" },
                  { label: 'Bill Pay List', separator: false, index: 3, hidden: !hasSecBp, name: "bill-list-sub-billpayList-button" },
                ]}
                onItemSelected={onCustomerBillAction}
              >
                Pay
              </ActionButton>&nbsp;
            </>
          }
          <>
            <ActionButton
              name='bill-list-viewhistory-button'
              type="primary"
              items={[
                { label: 'Payment History', separator: false, index: 0, hidden: !hasSelectedRow, name: "bill-list-payment-button" },
                { label: 'View History', separator: false, index: 1, hidden: !hasSelectedRow, name: "bill-list-history-button" },
                // { label: 'Delete History', separator: false, index: 2, hidden: !hasSelectedRow, name: "bill-list-viewdeletehistory-button" },
              ]}
              onItemSelected={onHistoryBtnAction}
            >
              View History
            </ActionButton>&nbsp;
          </>
          {/* <PrimaryButton size="regular" disabled={!hasSelectedRow} onClick={() => setSelectedPopupMenuItem({ label: 'Payment History', popupWidth: 1050, popupComponent: <PaymentHistory jobId={selectedElement.id} jobName={JobNames.Bill} /> })}>Payment History</PrimaryButton>&nbsp; 
        <PrimaryButton name='bill-list-payment-button' size="regular" disabled={!hasSelectedRow} onClick={viewPaymentHistory}>Payment History</PrimaryButton>&nbsp;
        <PrimaryButton name='bill-list-history-button' size="regular" disabled={!hasSelectedRow} onClick={() => setSelectedPopupMenuItem({ label: 'View History', popupWidth: 920, popupComponent: <HistoryView jobId={selectedElement.id} jobType={selectedElement.jobType} jobName={JobNames.Bill} viewDeleteHistory={false} /> })}>View History</PrimaryButton>&nbsp;*/}
        </>}
        
        {jobListContext.opType !== constants.opTypes.warehousing && (
          <>
            <PrimaryButton
              name='billings-bill-list-print-button'
              size='regular'
              disabled={!hasSelectedRow}
              onClick={() =>
                setSelectedPopupMenuItem({
                  label: 'Print Bill',
                  popupComponent: <PrintBill selectedElement={selectedElement} />,
                })
              }
            >
              Print
            </PrimaryButton>
            &nbsp;
          </>
        )}

        <PrimaryButton
          name='bill-list-vendorBalance-button'
          size="regular"
          disabled={!hasSelectedRow}
          onClick={vendorBalance}>
          Balance
        </PrimaryButton>
      </div>
      {!!selectedPopupMenuItem && !!selectedPopupMenuItem.popupComponent ? (
        <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen={!!selectedPopupMenuItem} title={selectedPopupMenuItem?.popupLabel || selectedPopupMenuItem?.label} width={`${selectedPopupMenuItem?.popupWidth || 540}px`}>
          {cloneElement(selectedPopupMenuItem.popupComponent!, { onPopupClose })}
        </IfmsModal>
      ) : null}
    </div>
  );
}

function TrancationImpactButtonCommands({ userId } : {userId: string}) {
  const jobListContext = useContext(JobListViewContext);
  const selectedElement = jobListContext.selectedElement as BillListItem;
  const {switchJournal} = useJournal();
  const suntekSettings = useSuntekSettings();
  
  if ((!suntekSettings.general?.allowViewJournalBillings && !userId.startsWith('@')) || jobListContext.opType !== constants.opTypes.warehousing) {
    return null;
  }

  return (
    <PrimaryButton
      size="regular"
      onClick={()=> switchJournal(JobNames.Bill, selectedElement.id)}>
      {constants.List_Journal}
    </PrimaryButton>
  );
}

function BillListToolbar() {
  return (
    <>
      <ListViewShortcutMenu />
    </>
  );
}

function BillListViewExtras({
  hideLogHistory
}: any,
) {
  useFunctionKeys({ onFunction: onFunctionKey });

  const appContext = useContext(ApplicationContext);
  const jobListContext = useContext(JobListViewContext);
  const listSec = findSecurityTask(appContext, (jobListContext.opType === constants.opTypes.warehousing ? FmsSecTask.WHBill : FmsSecTask.AcctBillList));
  const systemSettings = useSystemSettings();

  const { edit, view, switchToParent } = useSelectedBillOperations();

  const [unprocessedFkey, setUnprocessedFkey] = useState<string | null>(null);

  useEffect(() => {
    if (!unprocessedFkey) {
      return;
    }

    doProcessFkey();
  },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [unprocessedFkey]
  );

  function doProcessFkey() {
    if (unprocessedFkey === 'F6') {
      switchToParent();
    } else if (unprocessedFkey === "F3") {
      if(listSec?.grantEdit)
        edit();
    } else if (unprocessedFkey === "F9") {
      view();
    } else if (unprocessedFkey === "F11") {
      jobListContext.reloadData();
    } else if (unprocessedFkey === "F8") {
      jobListContext.setInfoAreaContent(jobListContext.infoAreaContent === 'memo' ? 'none' : 'memo');;
    }

    setUnprocessedFkey(null);
  }

  function onFunctionKey(fkey: string) {
    if (['F6', 'F3', 'F9', 'F11', 'F8'].indexOf(fkey) >= 0) {
      setUnprocessedFkey(fkey);
      return true;
    }

    return false;
  }

  /**
   * 
   * @param param { jobName, jobId, appContext, jobListContext } 
   * @returns 
   */
  async function loadBillHistory(param: any) {
    //const apiResult = await appContext.api.getOceanImportBillHistory(id);
    const apiResult = await appContext.api.getAcctHistory(param.jobName, param.jobId, (jobListContext.selectedElement as BillListItem).jobType, false);
    if (!apiResult || !apiResult.success) {
      return null;
    }

    return <BicInfoAreaHistory context="bill" historyData={apiResult.result} primaryCurrency={systemSettings?.primaryCurrency ?? ''} />
  }

  return (
    <InfoAreaDrawer
      showContent={jobListContext.infoAreaContent}
      jobName={JobNames.Bill}
      jobId={(jobListContext.selectedElement as BillListItem | null)?.id ?? 0}
      customTabs={[
        {
          headline: '',
          contentLoader: loadBillHistory,
          params: { appContext, jobListContext }
        },
      ]}
      onClose={() => jobListContext.setInfoAreaContent('none')}
      hideLogHistory={hideLogHistory}
    />
  );
}

/**
 * Concrete implementation for BILL (OI) List screen
 *
 * @class BillListView
 * @extends {AbstractListView}
 */
class BillListView extends AbstractListView {
  getTableSettings(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): TableSettings {
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat = systemSettings.useVat ?? false;
    let listType: JobNames.Bill | JobNames.WHBill | JobNames.GBill = JobNames.Bill;
    if (opType === constants.opTypes.warehousing) {
      listType = JobNames.WHBill;
    }

    const tsettings = billList;
    const cols = BillListItem.getExportCollection(listType, useBranch, useVat);
    tsettings.columns = cols.map<TableColumn>(x => {
      return { ...x, accessor: x.dataIndex, Header: x.text, filterType: undefined, filterTypeV2: x.type };
    });
    return tsettings;
  }

  getDefaultOrderBy(): ListOrderBy {
    return {
      orderBy: 'updated',
      orderByAscending: false,
    };
  }

  getCustomFilterRenderers(opType?: string | undefined): ListCustomFilterRenderer[] {
    return [
      {
        accessor: 'statusNotUseFileLocked',
        renderer: StatusNotUseFileLockedRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'recognized',
        renderer: RecognizedFilterRenderer,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      {
        accessor: 'jobType',
        renderer: (props: any) => <BicTypeFilterRenderer opType={opType} acctType={'BIL'} {...props} />,
        searchValueExtractor: (v: any | null | undefined) => v,
      },
      //{
      //  accessor: 'draft',
      //  renderer: DraftFilterRenderer,
      //  searchValueExtractor: (v: any | null | undefined) => v === 'D' ? true : false,
      //},
      // {
      //   accessor: 'void',
      //   renderer: VoidFilterRenderer,
      //   searchValueExtractor: (v: any | null | undefined) => v === 'V' ? 1 : 0,
      // },
      {
        accessor: 'confirmed',
        renderer: undefined,
        searchValueExtractor: (v: any | null | undefined) => v.value !== undefined ? v.value : v,
      },
    ];
  }

  getRowRenderers(opType:string, systemSettings:SystemSettings, suntekSettings:SuntekSettings): ListRowRenderer[] {
    const useBranch = systemSettings?.enableBranch ?? false;
    const useVat = systemSettings.useVat ?? false;
    let listType: JobNames.Bill | JobNames.WHBill | JobNames.GBill = JobNames.Bill;
    if (opType === constants.opTypes.warehousing) {
      listType = JobNames.WHBill;
    }

    return BillListItem.getExportCollection(listType, useBranch, useVat).map(x => {
      const colRenderer: ListRowRenderer = { accessor: x.dataIndex, Cell: TextAlignLeftRenderer };
      if (x.align === XCol.XAlignType.Center) colRenderer.Cell = TextRenderer;
      if (x.align === XCol.XAlignType.Right) colRenderer.Cell = TextAlignRightRenderer;
      if (x.dataIndex === "status") {
        colRenderer.Cell = IndicatorRenderer;
      }
      else if (x.dataIndex === "draft") {
        // colRenderer.Cell = DraftRenderer;
        colRenderer.Cell = NullableCheckboxIconRenderer;
      }
      // else if (x.dataIndex === "void") {
      //   colRenderer.Cell = VoidRenderer;
      // }
      else if (x.dataIndex === "period") {
        colRenderer.Cell = PeriodRenderer;
      }
      else if (x.dataIndex === "amount" || x.dataIndex === "paidAmount" || x.dataIndex === "balance" || x.dataIndex === "cAmount" || x.dataIndex === "dutyAmount" ||x.dataIndex ==="vatAmount") {
        colRenderer.Cell = props => <CurrencyAmountRenderer currencyAccessor={(x: any) => x.currency} {...props} />;
      } else if (x.dataIndex === 'recognized') {
        colRenderer.Cell = RecognizedRenderer;
      }
      else if (x.dataIndex === "confirmed") {
        colRenderer.Cell = ConfirmedRenderer;
      }
      else if (x.dataIndex === "refNo" || x.dataIndex === "hblNo") {
        colRenderer.Cell = TextAlignLeftRenderer;
      }
      else if (x.type === XCol.XCellType.Bool || x.type === XCol.XCellType.StrBool) colRenderer.Cell = NullableCheckboxIconRenderer;
      else if (x.type === XCol.XCellType.Date) colRenderer.Cell = DateRenderer;
      else if (x.type === XCol.XCellType.DateTime) colRenderer.Cell = DateTimeRenderer;
      return colRenderer;
    });
  }
  
  getExportRenderers(): ExportRowRenderer[] {
    const colRenderer = [];
    colRenderer.push({ accessor: 'status', changedValue: (value: any) => { return value['status'] === 'PC' ? 'Period Close' : '' } });
    colRenderer.push({ accessor: 'amount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['amount']) } });
    colRenderer.push({ accessor: 'paidAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['paidAmount']) } });
    colRenderer.push({ accessor: 'balance', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['balance']) } });
    colRenderer.push({ accessor: 'cAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['cAmount']) } });
    colRenderer.push({ accessor: 'dutyAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['dutyAmount']) } });
    colRenderer.push({ accessor: 'vatAmount', changedValue: (value: any) => { return CurrencyAmountValue(value['currency'], value['vatAmount']) } });
    colRenderer.push({ accessor: 'draft', changedValue: (value: any) => { return nullableCheckBoxValue(value['draft'])} });
    colRenderer.push({ accessor: 'confirmed', changedValue: (value: any) => { return nullableCheckBoxValue(value['confirmed'])} });
    return colRenderer;
  }

  async fetchAndFormatData(api: any, search: Search, opType: string | undefined): Promise<DataFetchResult> {
    BillListItem.calculateSearchParameters(search, BillListItem.MapSearchFields, ['void']);

    const searchModel = BillListItem.calculateSearchParameters(search, BillListItem.MapSearchFields, ['void']);
    if (opType === constants.opTypes.oceanImport) searchModel.extraWhere = JobNames.OceanImport;
    else if (opType === constants.opTypes.oceanExport) searchModel.extraWhere = JobNames.OceanExport;
    else if (opType === constants.opTypes.airImport) searchModel.extraWhere = JobNames.AirImport;
    else if (opType === constants.opTypes.airExport) searchModel.extraWhere = JobNames.AirExport;
    else if (opType === constants.opTypes.otherShipment) searchModel.extraWhere = JobNames.OtherOP;

    const apiResult = await api.getListItems(opType === constants.opTypes.warehousing ? JobNames.WHBill : JobNames.Bill,
      'BillListItem',
      searchModel,
      1,
      search.pageSize,
    );

    if (!apiResult || !apiResult.entities || apiResult.entities.length <= 0) {
      return { data: [], totalCount: 0 };
    }

    return { data: formatData(apiResult.entities), totalCount: apiResult.totalCount };
  }

  renderCommands(): React.ReactNode {
    return (
      <BillListCommands />
    );
  }

  renderBeforeConfigureButton(): React.ReactNode {
    return (
      <BillListToolbar />
    );
  }



  renderExtras(hideLogHistory: boolean): React.ReactNode {
    return (
      <BillListViewExtras hideLogHistory={hideLogHistory} />
    );
  }

  getViewUrlFor(row: BillListItem) {
    if (!row.jobType) {
      return '';  // Not supported
    }

    return { url: row && row.id ? `/accounting/bill/view/${getJobNameFromInvBillCrDbJobType(row.jobType)}/${row.tbId}/${row.id}` : '', 
      needAfterScreenUrl: true, checkAllOperation: true };
  }

  getListViewTitle(opType: string | undefined) {
    return 'Bill List';
  };

  renderRowExtras(rowId: number | null, context: IJobListViewContext): React.ReactNode | null {
    if (!rowId) {
      return null;
    }

    const selectedBillNo = (context.data?.find(x => x.id === rowId) as BillListItem).billNo;

    function onPopupClose() {
      const storageKey = `bill-information-${rowId}`;
      fastStorage[storageKey] = null;
      context.setRowExtrasId(null);
    }

    return (
      <IfmsModal isBlueHeader cancelOnEsc onCancel={onPopupClose} draggable isOpen title={`Bill # : ${selectedBillNo}`} width="700px">
        <BillInformation billId={rowId} storageKey={`bill-information-${rowId}`} onPopupClose={onPopupClose} isView={false} />
      </IfmsModal>
    );
  }

  renderAdditionalCommands() {
    return <JobListSuntekCommand jobName={JobNames.Bill} keyProp='id' />;
  }

  hasRightClickContext(): boolean {
    return true;
  }

  renderRightClickContext(context: RightClickContext, dismiss: VoidFunction): React.ReactNode {
    return <RightClickMenu dismiss={dismiss} />;
  }
  
  useLogHistory(): boolean {
    return true;
  }

  transactionImpactBtn(userId: string): React.ReactNode {
    return <TrancationImpactButtonCommands userId={userId} />
  }
}

export default BillListView;
